import { Injectable } from '@angular/core';
import { ConfigResource } from '@df/catalog/config/config.resource';
import { Meta } from '@df/core/meta/meta';
import { NCmsMetaDataSchema } from '@icms/admin/editor/sidebar/settings/meta-data-schema/icms-admin-editor-sidebar-settings-meta-data-schema.component';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ICmsConfig } from '../resource/config/icms-config';
import { ICmsConfigResource } from '../resource/config/icms-config.resource';
import { StructuralDataService } from '@df/core/meta/structural-data/structural-data.service';

@Injectable({ providedIn: 'root' })
export class ICmsCoreAppSchemaService {
    /**
     * Currently active config entry
     */
    readonly config$ = new BehaviorSubject<ICmsConfig | undefined>(undefined);

    private modelSubscription?: Subscription;

    constructor(
        private configResource: ConfigResource,
        private structuralDataService: StructuralDataService,
        private meta: Meta
    ) {
        this.meta.subscribe(() => this.load());
        this.config$.subscribe(config => {
            this.apply();
            this.modelSubscription?.unsubscribe();
            if (config) {
                this.modelSubscription = config.change.subscribe(() => this.apply());
            }
        });
        this.load();
    }

    async load(): Promise<ICmsConfig | undefined> {
        const model = this.meta.model;
        if (model) {
            const config = await (this.configResource as any as ICmsConfigResource).retrieve(
                {
                    bareUrl: NCmsMetaDataSchema.configId,
                    variant: model.type + model.id,
                },
                undefined
            );
            // check if we are still onn this model
            if (model === this.meta.model) {
                if (this.config$.getValue() !== config) {
                    this.config$.next(config);
                }
            }
        } else {
            if (this.config$.getValue()) {
                this.config$.next(undefined);
            }
        }
        return this.config$.getValue();
    }

    private apply() {
        this.structuralDataService.setCustomSchema(this.config$.getValue()?.data?.content.schema);
    }
}
